// AppLayoutDrawer.jsx
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import React, { useContext } from "react";
import NAV from "../../nav";
import { Link } from "react-router-dom";
import PsContext from "../../../context";

const AppLayoutDrawer = ({ open, toggleDrawer }) => {
  const context = useContext(PsContext);
  const theme = useTheme();

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={toggleDrawer}
      sx={{
        "& .MuiDrawer-paper": {
          width: 280,
          background: theme.palette.background.paper,
          borderRight: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <Box role="presentation" onClick={toggleDrawer}>
        <List sx={{ py: 2 }}>
          {NAV.map((item, i) => {
            if (item.title === "divider")
              return <Divider key={`divider-${i}`} sx={{ my: 2 }} />;

            return (
              context.allowedAccess(item.module, item.action) && (
                <ListItem
                  key={i}
                  disablePadding
                  component={item.path ? Link : "div"}
                  to={item.path}
                >
                  <ListItemButton sx={{ px: 3, py: 1.5 }}>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <item.muiIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.title}
                      primaryTypographyProps={{ variant: "body1" }}
                    />
                  </ListItemButton>
                </ListItem>
              )
            );
          })}
        </List>
      </Box>
    </Drawer>
  );
};

export default AppLayoutDrawer;
